import { memo } from "react";

import { ConfirmModal } from "../../../../components/CustomModal/ConfirmModal";

interface IDeleteAnswerModalProps {
  onClose: () => void;
  onSuccess: () => void;
  isProcessing: boolean;
}

const DeleteAnswerModal: React.FC<IDeleteAnswerModalProps> = memo(
  ({ onClose, onSuccess, isProcessing }) => {
    return (
      <ConfirmModal
        visible={true}
        onCancel={onClose}
        onSubmit={onSuccess}
        title="Delete answer"
        text="The answer will be deleted permanently and this action cannot be undone. Are you sure you want to delete the answer?"
        okText="Delete"
        isProcessing={isProcessing}
      />
    );
  },
);

export { DeleteAnswerModal };
